






































import { Component, Vue ,Prop, Model} from 'vue-property-decorator'
import MainHeader from '@/components/MainHeader'
import { getDocumentListRequest, GetDocInfoById ,getDocInfoForEidt} from '@/api/supervision'
import { saveTempContent,editTempContent ,getTempDocInfo} from '@/api/system'
import TinymceEditor from '@/components/TinymceEditor'

@Component({
  components: { TinymceEditor,MainHeader },
})
export default class DocumentModal extends Vue {
@Prop({ type: Boolean }) readonly visible!: boolean;
@Prop({type:Object}) readonly docData!:any
@Prop({type:String}) readonly action!:any
@Prop({ type: Boolean }) readonly reset!: boolean;

  private documentList: any = [];
  private documentInfo: any = {
    documentName: undefined,
    documentContent: '',
    documentIssueState:'',
    documentIssueTime:'',
    id:''
  };
  private setContent: any;
  created() {
  }
  content: any = '';

private headerArr:any =[
  '文书模板管理',
  '新增文书'
]
 
 private disabled:Boolean =false
  mounted() {
    this.$nextTick(() => {
      this.setContent = this.$refs.editor
      // if(this.docData){
      //     this.documentInfo.documentName = {key:this.docData.id,label:this.docData.documentName},
      //     this.setContent.setContent(this.docData.documentContent),
      //     this.documentInfo.id = this.docData.id
      // }
    
    })


       if(this.$route.query.action==='update'){
         this.headerArr =[
  '文书模板管理',
  '编辑文书'
]
this.disabled = true

      getTempDocInfo(this.$route.query.id).then((res:any)=>{
        if(res&&res.status===0){
          this.$nextTick(() => {
          this.documentInfo.documentName = res.data.documentName,
          this.setContent.setContent(res.data.content),
          this.documentInfo.id = res.data.id
          })
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
  private getDocContent(e: any) {
    GetDocInfoById(e).then((res: any) => {
      if (res && res.status === 0) {
          setTimeout(()=>{ this.setContent = this.$refs.editor
          this.setContent.setContent(res.data.content)},300)
          this.documentInfo.documentIssueState = res.data.documentIssueState
           this.documentInfo.documentIssueTime = res.data.documentIssueTime
           this.documentInfo.id = res.data.id
        // this.$nextTick(() => {
        //   this.setContent = this.$refs.editor
        //   this.setContent.setContent(res.data.content)
        // })
      } else {
        this.$message.error(res.message)
      }
    })
  }
  handleOk() {
    const _this = this
    if(!this.documentInfo.documentName){
        this.$message.warning('请先填写文书名称')
        return 
    }
    if(this.setContent.value===''){
        this.$message.warning('请填写模板内容')
        return 
    }
      var docData:any = {
          documentName:this.documentInfo.documentName,
          content:this.setContent.value,
          
          //  documentIssueTime:this.documentInfo.documentIssueTime,
          //  documentIssueState:this.documentInfo.documentIssueState,
          //  id:this.documentInfo.id
      }
      if(this.$route.query.id){
        docData.id = this.$route.query.id
         editTempContent(docData).then((res:any)=>{
        if(res&&res.status===0){
          this.$message.success('编辑文书模板成功')
          this.handleReturn()

        } else {
          this.$message.error(res.message)
        }
      })
      } else{
      saveTempContent(docData).then((res:any)=>{
        if(res&&res.status===0){
          this.$message.success('新增文书模板成功')
          this.handleReturn()

        } else {
          this.$message.error(res.message)
        }
      })}
  }
  handleCancel() {
    this.documentInfo.documentName = undefined
    this.$emit('closeDoc')
  }
  private handleChange(e: any) {
    this.getDocContent(e.key)
  }
  // 返回按钮
  handleReturn() {
    this.$router.replace({ name: 'TempManage' })
  }
}
